import { createDeepEqualSelector } from './index';
import { SearchGlobalStateType } from '../../types';

export const launchesSelector = (state: SearchGlobalStateType) =>
  state.launches;

export const currentLaunchesSelector = createDeepEqualSelector(
  launchesSelector,
  (state) => state.launches ?? [],
);
